export default "__VITE_ASSET__BvxALWpg__"